export const MAX_LENGTH_NOTIFICATION = 3;
